import React, {FC} from 'react';

import {PriceWithUsd} from 'components/currency/price-with-usd';
import {calculateProductTotalPrice, calculateProductTotalPriceForDealer} from 'utils/quotes/calculator';

interface ProductTotalPriceProps {
    dealer?: boolean;
    price: number;
    quantity: number;
    commissionMultiplier: number;
    taxes?: {name: string, amount: number;}[];
    isSale?: boolean;
    exchangeRate?: number | null;
}

export const ProductTotalPrice: FC<ProductTotalPriceProps> = React.memo(({
    price,
    quantity,
    commissionMultiplier,
    dealer,
    taxes,
    exchangeRate,
}) => {
    const brlAmount = !dealer
        ? calculateProductTotalPrice(price, quantity, taxes)
        : calculateProductTotalPriceForDealer(price, commissionMultiplier, quantity, taxes);
    return <PriceWithUsd brlAmount={brlAmount} exchangeRate={exchangeRate} />;
});
